import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdcuListingCalendarMain from './listing-calendar/listing-calendar-main';

const AdcuListingCalendar = () => {
  return (
    <Routes>
      <Route index element={<AdcuListingCalendarMain />} />
    </Routes>
  )
}

export default AdcuListingCalendar;
